
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WizardBackButton',

  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
});
